import React from 'react'
import classNames from 'classnames'

import {
  calculatePackageCount,
  getOneUomPluralized,
} from '~/components/dashboard/admin/catalog/inventory/inventoryUtils'

import styles from './FormattedQuantityDisplay.module.scss'

export type FormattedQuantityDisplayVariant =
  | 'receiving'
  | 'rejecting'
  | 'remaining'

interface FormattedQuantityDisplayProps {
  className?: string
  packageTypeName: string
  packageUnitsName: string
  perPackageAmount: number
  quantity: number
  variant?: FormattedQuantityDisplayVariant
}

export const FormattedQuantityDisplay = ({
  className,
  packageTypeName,
  packageUnitsName,
  perPackageAmount,
  quantity,
  variant,
}: FormattedQuantityDisplayProps) => {
  const consumptionAmount = quantity
  const packageAmount = calculatePackageCount(quantity, perPackageAmount)

  const consumptionUnit = getOneUomPluralized(
    packageUnitsName,
    consumptionAmount,
  )
  const packageUnit = getOneUomPluralized(packageTypeName, packageAmount)

  return (
    <span
      className={classNames(
        styles.container,
        variant && styles[variant],
        className,
      )}
    >
      <span className={styles.consumption}>
        {consumptionAmount} {consumptionUnit}
      </span>
      <span className={styles.package}>
        ({packageAmount} {packageUnit})
      </span>
    </span>
  )
}
